<template>
  <div class="q-gutter-md">
    <form-field
      v-for="(field, fieldIndex) of fieldList"
      :key="fieldIndex"
      :field="field"
      v-model="values[field.name]"
      @on-enter="$emit('submit', values)"
    ></form-field>
    <div class="text-right">
      <q-btn
        :label="submitLabel"
        color="primary"
        class="q-px-md"
        unelevated
        @click="$emit('submit', values)"
      ></q-btn>
    </div>
  </div>
</template>

<script>
import formField from "./formField";
import { defineComponent } from "vue";

export default defineComponent({
  name: "system-form",

  data() {
    return {
      values: {},
    };
  },

  props: {
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
    submitLabel: {
      type: String,
      default: "Enviar",
    },
  },

  computed: {
    fieldList() {
      let fieldArray = [];
      for (let fieldName in this.fields) {
        fieldArray.push({
          name: fieldName,
          ...this.fields[fieldName],
        });
      }
      return fieldArray;
    },
  },

  components: {
    "form-field": formField,
  },

  created() {
    // verifica se há valores padrões e coloca na variável
    for (let field of this.fieldList) {
      if (typeof field.model !== "undefined") {
        this.$set(this.values, field.name, field.model);
      }
    }
  },
});
</script>

<style>
</style>